import request from '../../config/Request'

const userApi = {
    Login: '/api/login/doLogin',
    buildQualificationAlarm: 'api/alarm/buildQualificationAlarm',//生成资质告警数据
};

/**
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
    return request({
        url: userApi.Login,
        data: parameter
    })
}

/**
 * @param parameter
 * @returns {*}
 */
export function buildQualificationAlarm(parameter) {
    return request({
        url: userApi.buildQualificationAlarm,
        data: parameter
    })
}

//获取用户信息
export function getInfo() {
    let user = sessionStorage.getItem('user');
    if (user === null || user.length < 1) {
        return null
    }
    return JSON.parse(user)
}

//设置用户信息
export function setInfo(user) {
    sessionStorage.setItem('user', JSON.stringify(user))
}